import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/loads/$id/agreement")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/loads/$id", params: { id: params.id } });
  },
  component: () => null,
});
